import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";


export type PropertyItem = {
    propertyName: string,
    propertyValue: string
}

interface SummaryProps {
    data: PropertyItem[],
}

export const Summary = (props: SummaryProps) => {
    return (<>

        {props.data.map((property, index) => (
            <SumamryWraper key={index}>
                <SummaryItemName>{property.propertyName}</SummaryItemName>
                <SummaryItemValue>{property.propertyValue}</SummaryItemValue>
            </SumamryWraper >
        ))}

    </>
    );
};
const SumamryWraper = styled.div`
display: flex;
flex-direction: row;
width:100%;
`;
const SummaryItemName = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
padding-bottom:16px;
width:30%;
overflow-wrap: break-word;
padding-right:10px;
@media ${theme.device.laptop} {
    padding-right:5px;
  }
`;

const SummaryItemValue = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-bottom: 16px;
width:70%;

`;
